module.exports = __webpack_public_path__ + "img/pro_two_12.ceac3997.jpg";